/* unplugin-vue-components disabled */import { render } from "./LikeMv.vue?vue&type=template&id=735fb079&scoped=true"
import script from "./LikeMv.vue?vue&type=script&lang=js"
export * from "./LikeMv.vue?vue&type=script&lang=js"

import "./LikeMv.vue?vue&type=style&index=0&id=735fb079&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735fb079"]])

export default __exports__